import { render, staticRenderFns } from "./NewQualification.vue?vue&type=template&id=a7fa4430"
import script from "./NewQualification.vue?vue&type=script&lang=js"
export * from "./NewQualification.vue?vue&type=script&lang=js"
import style0 from "./NewQualification.vue?vue&type=style&index=0&id=a7fa4430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports